// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// luismrosero1992@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyBm5lqTKBdKFU6fnKWvslNXD4hkaPJNtJ4",
    authDomain: "creencia-central-71dde.firebaseapp.com",
    projectId: "creencia-central-71dde",
    storageBucket: "creencia-central-71dde.firebasestorage.app",
    messagingSenderId: "605266717642",
    appId: "1:605266717642:web:b471f69307ecfb9c67bd33",
    measurementId: "G-Y83TFZHJLX"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)